import { Component } from '@angular/core';

@Component({
  selector: 'intrasense-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Intrasense';



}
